import DialogContent from '@zenbusiness/zui/DialogContent';
import Heading from '@zenbusiness/zui/Heading';
import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { ActionTwoButtonsGrid, FocusGrid, ContainerGrid } from '#client/components/Grid';
import useEnterSubmit from '#client/hooks/useEnterSubmit';
import useUnFreezeCard from '#client/hooks/useUnfreezeCard';

import { Wrapper } from '../UnfreezeCardModal.styles';

export default function UnfreezeCardForm({ cardId, last4Digits, handleClose }) {
  const { handleUnfreezeCard, loading: unfreezeCardLoading } = useUnFreezeCard(cardId, handleClose);
  const unFreezeButtonId = useEnterSubmit();

  return (
    <>
      <DialogContent>
        <ContainerGrid>
          <FocusGrid>
            <Wrapper spacing="32px">
              <Stack spacing="16px">
                <Heading
                  family="secondary"
                  size="3xl"
                  weight="bold"
                >
                  Are you sure you want to unfreeze your card ending in {last4Digits}?
                </Heading>
                <Text
                  color="secondary"
                  size="lg"
                >
                  This means your card will be active and ready to use again.
                </Text>
              </Stack>
            </Wrapper>
          </FocusGrid>
        </ContainerGrid>
      </DialogContent>
      <ActionTwoButtonsGrid
        firstButton={
          <LoadingButton
            disabled={unfreezeCardLoading}
            fullWidth
            onClick={handleClose}
            size="large"
            variant="outlined"
          >
            No thanks
          </LoadingButton>
        }
        secondButton={
          <LoadingButton
            color="primary"
            disabled={unfreezeCardLoading}
            fullWidth
            id={unFreezeButtonId}
            loading={unfreezeCardLoading}
            onClick={handleUnfreezeCard}
            size="large"
            variant="contained"
          >
            Unfreeze card
          </LoadingButton>
        }
      />
    </>
  );
}

UnfreezeCardForm.propTypes = {
  cardId: PropTypes.string.isRequired,
  last4Digits: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired
};
